import { useState, useEffect } from "react";
import { RelatorioFiltrar, RelatorioImprimir } from "src/services/Relatorio.Service";
import { EmpresaBuscarPorUsuario } from "src/services/Entidade.Service";
import { showToast } from "src/componentes";
import { MapearErrosServidor } from "src/hook/Functions";
import { EmpresaDto } from "src/pages/Privada/Entidade/Empresa/Empresa.Dto";
import { NFCeDto } from "../../NFCe.Dto";
import { EModulo, ESubModulo, RelatorioDto, RelatorioImprimirInput } from "src/pages/Privada/Sistema/Relatorio/RelatorioSistema.Dto";

export interface NFCeModalRelatorioProps {
  show: boolean;
  onHide: () => void;
  data: NFCeDto[];
  modulo: EModulo;
  subModulo: ESubModulo;
}

const NFCeModalRelatorioCode = (props: NFCeModalRelatorioProps) => {
  const [loading, setLoading] = useState(false);
  const [relatorios, setRelatorios] = useState<RelatorioDto[]>([]);
  const [relatorioSelecionado, setRelatorioSelecionado] = useState<number | "">("");

  useEffect(() => {
    if (props.show) {
      fetchRelatorios();
    }
  }, [props.show]);

  const fetchRelatorios = async () => {
    setLoading(true);
    try {
      const response = await RelatorioFiltrar({
        modulo: props.modulo,
        subModulo: props.subModulo,
      });
      if (response.data.success) {
        setRelatorios(response.data.data);
        if (response.data.data.length > 0) {
          setRelatorioSelecionado(response.data.data[0].id);
        }
      } else {
        MapearErrosServidor(response.data.notifications, showToast);
      }
    } catch (error) {
      console.error(error);
      showToast({ message: "Erro ao buscar relatórios", variant: "Danger" });
    } finally {
      setLoading(false);
    }
  };

  const handleImprimir = async () => {
    if (!relatorioSelecionado) {
      showToast({ message: "Selecione um relatório", variant: "Warning" });
      return;
    }

    setLoading(true);
    try {
      // 1. Buscar dados da empresa
      const empresaResponse = await EmpresaBuscarPorUsuario();
      if (!empresaResponse.data.success) {
        MapearErrosServidor(empresaResponse.data.notifications, showToast);
        setLoading(false);
        return;
      }

      const empresa = empresaResponse.data.data;

      // 2. Preparar payload
      const payload: RelatorioImprimirInput<{ empresa: EmpresaDto; nfce: NFCeDto[] }> = {
        id: Number(relatorioSelecionado),
        data: {
          empresa: empresa,
          nfce: props.data,
        },
      };

      // 3. Chamar endpoint de impressão
      const printResponse = await RelatorioImprimir(payload);
      
      // 4. Abrir PDF em nova aba
      const file = new Blob([printResponse.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL, "_blank");
      
      props.onHide();
    } catch (error) {
      console.error(error);
      showToast({ message: "Erro ao gerar relatório", variant: "Danger" });
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    relatorios,
    relatorioSelecionado,
    setRelatorioSelecionado,
    handleImprimir,
  };
};

export default NFCeModalRelatorioCode;
